export const GIT_COMMIT = 'b86d0f11e5cdd31ab39161bfeefc0474111231d7';
